import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";

import { useLingui } from "@lingui/react";

import { messageText } from "../../lib/form";
import type { FormMessage, ValueFieldOf } from "../../lib/form";

export type UseField<TValue> = {
  value: TValue;
  setValue: (value: TValue) => void;
  error: string | null;
  errors: FormMessage[];
  hasError: boolean;
  touched: boolean;
  touch: () => void;
};

export function useField<TValue>(
  field: ValueFieldOf<TValue>,
): UseField<TValue> {
  const { i18n } = useLingui();

  const [value, setValue] = useAtom(field.atom);
  const errors = useAtomValue(field.errorsAtom);
  const touched = useAtomValue(field.touchedAtom);
  const touch = useSetAtom(field.touch);
  const mount = useSetAtom(field.mount);

  useEffect(() => mount(), [mount]);

  const first = errors[0];

  return {
    value,
    setValue: (next: TValue) => {
      setValue(next);
      touch();
    },
    error:
      undefined === first
        ? null
        : "string" === typeof first
          ? first
          : i18n._(first),
    errors,
    hasError: 0 < errors.length,
    touched,
    touch: () => touch(),
  };
}

export { messageText };
